import { PortfolioSlider } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/portfolio_slider';
import { ElementType } from '@fiverr-private/bianka_js';
import { CommonElementAttrs } from '../types';
import { reportPortfolioSliderClick } from './reports/portfolioSlider';

interface CommonEventAttrs {
    sellerId: string;
    sellerProfessionId?: string;
}

type PortfolioSliderClicked = (attrs: CommonElementAttrs & { additionalDataMessage: PortfolioSlider }) => void;

export interface PortfolioBIEvents {
    reportServicesTagFilterClicked: PortfolioSliderClicked;
    reportPortfolioCardClicked: PortfolioSliderClicked;
    reportSliderScrollClicked: PortfolioSliderClicked;
    reportGetQuoteButtonClicked: PortfolioSliderClicked;
    reportMediaPlayButtonClicked: PortfolioSliderClicked;
}

interface PortfolioSliderEventsAdditionalData {
    additionalDataMessage: Omit<PortfolioSlider, 'sellerProfessionId'>;
}

export const createPortfolioSliderEvents = ({ sellerId, sellerProfessionId }: CommonEventAttrs): PortfolioBIEvents => ({
    reportServicesTagFilterClicked: ({
        label,
        additionalDataMessage,
    }: CommonElementAttrs & PortfolioSliderEventsAdditionalData) =>
        reportPortfolioSliderClick({
            sellerId,
            eventName: 'clicked_on_profession_services_tag_filter',
            componentType: ElementType.BUTTON,
            componentName: 'profession_services_tag_filter',
            componentLabel: label,
            additionalDataMessage: {
                ...additionalDataMessage,
                sellerProfessionId,
            },
        }),

    reportPortfolioCardClicked: ({
        label,
        additionalDataMessage,
    }: CommonElementAttrs & PortfolioSliderEventsAdditionalData) =>
        reportPortfolioSliderClick({
            sellerId,
            eventName: 'clicked_on_portfolio_by_selected_services_card_clicked',
            componentType: ElementType.BUTTON,
            componentName: 'portfolio_by_selected_services_card_clicked',
            componentLabel: label,
            additionalDataMessage: {
                ...additionalDataMessage,
                sellerProfessionId,
            },
        }),

    reportSliderScrollClicked: ({
        label,
        additionalDataMessage,
    }: CommonElementAttrs & PortfolioSliderEventsAdditionalData) =>
        reportPortfolioSliderClick({
            sellerId,
            eventName: 'clicked_on_portfolio_by_selected_services_project_scroll_buttons',
            componentType: ElementType.BUTTON,
            componentName: 'portfolio_by_selected_services_project_scroll_buttons',
            componentLabel: label,
            additionalDataMessage: {
                ...additionalDataMessage,
                sellerProfessionId,
            },
        }),

    reportGetQuoteButtonClicked: ({
        additionalDataMessage,
        label,
    }: CommonElementAttrs & PortfolioSliderEventsAdditionalData) =>
        reportPortfolioSliderClick({
            sellerId,
            eventName: 'seller_page.click_on_get_quote',
            componentType: ElementType.BUTTON,
            componentName: 'portfolio',
            componentLabel: label,
            additionalDataMessage: {
                ...additionalDataMessage,
                sellerProfessionId,
            },
        }),

    reportMediaPlayButtonClicked: ({
        label,
        additionalDataMessage,
    }: CommonElementAttrs & PortfolioSliderEventsAdditionalData) =>
        reportPortfolioSliderClick({
            sellerId,
            eventName: 'clicked_on_portfolio_by_selected_services_project_media',
            componentType: ElementType.BUTTON,
            componentName: 'portfolio_by_selected_services_project_media',
            componentLabel: label,
            additionalDataMessage: {
                ...additionalDataMessage,
                sellerProfessionId,
            },
        }),
});
